import React from 'react';
import Icon from '../../../../components/AppIcon';
import Button from '../../../../components/ui/Button';

const InterviewTypeCard = ({ 
  type, 
  title, 
  description, 
  duration, 
  difficulty, 
  icon, 
  onStart 
}) => {
  const difficultyColors = {
    beginner: 'bg-success/10 text-success',
    intermediate: 'bg-warning/10 text-warning',
    advanced: 'bg-error/10 text-error'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-all duration-150 ease-out group">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors duration-150 ease-out">
          <Icon name={icon} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground">{duration}</span>
        </div>
        <div className={`px-3 py-1 rounded-full text-xs font-medium ${difficultyColors?.[difficulty]}`}>
          {difficulty?.charAt(0)?.toUpperCase() + difficulty?.slice(1)}
        </div>
      </div>
      <Button
        variant="default"
        fullWidth
        iconName="Play"
        iconPosition="left"
        onClick={() => onStart(type)}
      >
        Start Interview
      </Button>
    </div>
  );
};

export default InterviewTypeCard;